import React, { useEffect, useState, useContext } from "react"
import { Link } from "gatsby"
import { BreadcrumbsContext } from "../../contexts/breadcrumbs"
import { graphql } from "gatsby"
import ArrowLeft from "icons/arrow_left.svg"

interface BreadcrumbsItem {
  href: string
  title: string
}

interface BreadcrumbsProps {
  showFor: "desktop" | "mobile"
}

export const query = graphql`
  fragment BreadcrumbsItemFields on DatoCmsBreadcrumbsItem {
    id
    from
    to
  }
`

const Breadcrumbs = ({ showFor }: BreadcrumbsProps) => {
  const [firstNavigationObject, setFirstNavigationObject] =
    useState<BreadcrumbsItem>()
  const [secondNavigationObject, setSecondNavigationObject] =
    useState<BreadcrumbsItem>()

  const breadcrumbsData: Queries.BreadcrumbsItemFieldsFragment[] =
    useContext(BreadcrumbsContext)

  const toBreadcrumbs = (splittedPathname: string[]) => {
    return splittedPathname.reduce(
      (accumulator: BreadcrumbsItem[], currentValue: string, index: number) => {
        // Generate full path for the current path
        const href = "/" + splittedPathname.slice(0, index + 1).join("/") + "/"
        const titleFromUrl = currentValue.replace(/-/g, " ")

        // Check if we have any overrides of the title coming from Dato
        const indexOfOverride =
          breadcrumbsData && Array.isArray(breadcrumbsData)
            ? breadcrumbsData.findIndex(
                breadcrumbsItem =>
                  breadcrumbsItem &&
                  breadcrumbsItem.from?.localeCompare(titleFromUrl, undefined, {
                    sensitivity: "base",
                  }) === 0,
              )
            : null

        // If we found an override, let's use it. Otherwise we will use the default generated one.
        const title =
          indexOfOverride !== null && indexOfOverride >= 0
            ? breadcrumbsData[indexOfOverride].to || titleFromUrl
            : titleFromUrl

        accumulator.push({
          href,
          title,
        })
        return accumulator
      },
      [{ href: "/", title: "Home" }] as BreadcrumbsItem[],
    )
  }

  useEffect(() => {
    const pathname = window.location.pathname
    const trimmedPathname =
      pathname.charAt(0) === "/" ? pathname.replace("/", "") : pathname
    const pathnameParts = trimmedPathname.split("/").filter(Boolean)

    if (pathnameParts.length >= 3) {
      const breadcrumbs = toBreadcrumbs(pathnameParts)
      setFirstNavigationObject(breadcrumbs[breadcrumbs.length - 2])
      setSecondNavigationObject(breadcrumbs[breadcrumbs.length - 1])
    }
  }, [])

  if (
    firstNavigationObject &&
    secondNavigationObject &&
    (showFor === "desktop" || showFor === "mobile") &&
    !firstNavigationObject.href.includes("/tag/") // Do not render if the page includes tags has we do not have any overview page for it.
  ) {
    return (
      <nav id="menu-breadcrumbs" className={`c-breadcrumbs -${showFor}`}>
        <a href={firstNavigationObject.href}>
          <ArrowLeft className="c-breadcrumbs__arrow" />
        </a>
        <span className="c-breadcrumbs__line" />
        <div>
          <Link
            className="c-breadcrumbs__item"
            to={firstNavigationObject.href}
            activeClassName="-active"
          >
            {firstNavigationObject.title}
          </Link>
          <span className="c-breadcrumbs__dash">/</span>
          <Link
            className="c-breadcrumbs__item"
            to={secondNavigationObject.href}
            activeClassName="-active"
          >
            {secondNavigationObject.title}
          </Link>
        </div>
      </nav>
    )
  } else {
    return null
  }
}

export default Breadcrumbs
